var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-10" },
      [
        _c("settings-property", {
          attrs: {
            label: _vm.resource(
              "JourneyComposer_BrickSettingsAudienceFilter_ConditionFieldType_DisplayName"
            )
          },
          scopedSlots: _vm._u([
            {
              key: "input",
              fn: function(ref) {
                var id = ref.id
                return [
                  _c("v-select", {
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      options: _vm.fieldTypes,
                      clearable: false,
                      disabled: !_vm.canWrite || !_vm.fieldTypes.length
                    },
                    model: {
                      value: _vm.typeModel,
                      callback: function($$v) {
                        _vm.typeModel = $$v
                      },
                      expression: "typeModel"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-2" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-danger",
          attrs: { disabled: !_vm.canWrite },
          on: {
            click: function($event) {
              return _vm.$emit("delete")
            }
          }
        },
        [_c("i", { staticClass: "fa fa-trash" })]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-10" },
      [
        _c("settings-property", {
          attrs: {
            label: _vm.resource(
              "JourneyComposer_BrickSettingsAudienceFilter_ConditionFieldValue_DisplayName"
            )
          },
          scopedSlots: _vm._u([
            {
              key: "input",
              fn: function(ref) {
                var id = ref.id
                return [
                  !_vm.isDropdown
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.valueModel,
                            expression: "valueModel"
                          }
                        ],
                        key: id,
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          "input-id": id,
                          disabled: !_vm.canWrite
                        },
                        domProps: { value: _vm.valueModel },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.valueModel = $event.target.value
                          }
                        }
                      })
                    : _c("v-select", {
                        key: id,
                        staticClass: "form-control",
                        attrs: {
                          "input-id": id,
                          options: _vm.dropdownValues,
                          disabled:
                            !_vm.canWrite || _vm.dropdownValues.length === 0,
                          searchable: "",
                          filterable: ""
                        },
                        model: {
                          value: _vm.valueModel,
                          callback: function($$v) {
                            _vm.valueModel = $$v
                          },
                          expression: "valueModel"
                        }
                      })
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }